let brandDomain: string

export function getBrandDomain(hostname = window.location.hostname): string {
  if (!brandDomain || hostname) {
    brandDomain = hostname.indexOf('co.uk') !== -1 ?
      hostname.split('.').slice(-3).join('.') :
      hostname.split('.').slice(-2).join('.')
  }

  return brandDomain
}
